import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Services from "@/components/landing/Services";
import WhyUs from "@/components/landing/WhyUs";
import Process from "@/components/landing/Process";
import Stats from "@/components/landing/Stats";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative">
      <Navbar />
      <Hero />
      <Services />
      <WhyUs />
      <Process />
      <Stats />
      <FinalCTA />
      <Footer />
    </main>
  );
}
